"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
var _Dialog = require("../../components/Dialog/Dialog.styles");
var _DialogBody = require("../../components/DialogBody/DialogBody.styles");
var _spaceMixin = require("../spaceMixin");
var _PopoverMixin = require("./PopoverMixin");
/** @class TooltipMixin */
/** @method */
var TooltipMixin = function TooltipMixin(props) {
  return (0, _styledToken.default)({
    dialogBodyPaddingX: 'Tooltip.DialogBody.paddingX',
    dialogBodyPaddingY: 'Tooltip.DialogBody.paddingY'
  }, function (_ref) {
    var dialogBodyPaddingX = _ref.dialogBodyPaddingX,
      dialogBodyPaddingY = _ref.dialogBodyPaddingY;
    return (0, _styledComponents.css)(["", " ", "{max-height:none;width:auto;&:after{content:none;}}", "", "{padding:", ";&:after{content:none;}}"], (0, _PopoverMixin.PopoverMixin)(props), _Dialog.StyledDialog, _DialogBody.StyledDialogBody, _DialogBody.StyledDialogBody, dialogBodyPaddingX && dialogBodyPaddingY ? dialogBodyPaddingY + "px " + dialogBodyPaddingX + "px" : (0, _spaceMixin.spaceMixin)('xs')(props) + " " + (0, _spaceMixin.spaceMixin)('sm')(props));
  })(props);
};
exports.TooltipMixin = TooltipMixin;